module.exports = __webpack_public_path__ + "static/img/trainingContent.9b6d77eb.png";